module.exports = __webpack_public_path__ + "static/media/IMG-5.ff5a78f8.jpg";